import moment from 'moment-timezone'

/**
 * Juniper/mc2 APIs store and serialize timestamps in UTC, often without a
 * timezone suffix ("Y-m-d H:i:s"). Plain moment(ts) would read those as the
 * viewer's local wall time and show everything shifted (e.g. 2h for CEST).
 * Always parse as UTC, then convert to the viewer's local zone.
 */
export function utcToLocal(ts) {
	return moment.utc(ts).local()
}

export function fromNowUtc(ts) {
	if (!ts) return ''
	return utcToLocal(ts).fromNow()
}

export function formatUtc(ts, format = 'MMMM D, YYYY [at] h:mm A') {
	if (!ts) return ''
	return utcToLocal(ts).format(format)
}
